import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { makeStyles, Grid, Chip } from '@material-ui/core';
import {
  Dialog,
  Panel,
  Typography,
  DateTimePicker,
  Loader,
  List,
  IllustrationInfo,
  FilterChipMenu,
} from 'components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useReduxDispatch, useReduxSelector } from 'store/hooks';
import UserPhoto from 'views/common/UserPhoto';
import { fetchAppealRequests } from 'store/appealRequest';
import { useSelector } from 'react-redux';
import AppealDetail from './AppealDetail';
import EditAppealDialog from './EditAppealDialog';
import { STATUSES, LEAVE_TYPE } from 'config/leaveStatus';
import FilterDateDialog from './FilterDateDialog';

const useStyles = makeStyles((theme) => ({
  rootList: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
  },
  detailContainer: {
    marginLeft: 15,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: 'calc(100% - 60px)',
  },
  buttonView: {
    padding: '2px 10px',
    borderRadius: 25,
    backgroundColor: '#c2e1fb',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    margin: 5,
  },
  chipApproved: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 18,
    borderRadius: 24,
    paddingRight: 8,
    paddingLeft: 8,
    marginLeft: 4,
    border: '1px solid rgba(1, 197, 138, 0.25)',
    backgroundColor: 'rgba(1, 197, 138, 0.12)',
  },
  chipPending: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 18,
    borderRadius: 24,
    paddingRight: 8,
    paddingLeft: 8,
    marginLeft: 4,
    border: '1px solid rgba(251, 179, 39, 0.25)',
    backgroundColor: '#FFEFCE',
  },
  chipRejected: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 18,
    borderRadius: 24,
    paddingRight: 8,
    paddingLeft: 8,
    marginLeft: 4,
    border: '1px solid rgba(239, 64, 64, 0.25)',
    backgroundColor: '#FFD6D6',
  },
}));

const STATUS_KEYS = {};
const FONT_COLOR = {
  pending: '#FBB327',
  approved: '#01C58A',
  rejected: '#EF4040',
};

// eslint-disable-next-line no-return-assign
STATUSES.forEach((e) => (STATUS_KEYS[e.id] = e.label));

export default React.memo((props) => {
  const classes = useStyles();
  const getAppealRequest = useReduxDispatch(fetchAppealRequests);
  const { env } = useSelector((state) => state.app);
  const appealRequest = useReduxSelector((state) => state.appealRequest);
  const [selected, setSelected] = useState({});
  const [openFilterDate, setOpenFilterDate] = useState(false);
  const [action, setAction] = useState();
  const [selectedAppeal, setSelectedAppeal] = useState();
  const [draftEditLeave, setDraftEditLeave] = useState();
  const [openDownload, setOpenDownload] = useState(false);
  const [downloadStartDate, setDownloadStartDate] = useState(new Date().setDate(0));
  const [downloadEndDate, setDownloadEndDate] = useState(new Date());
  const [statusFilter, setStatusFilter] = useState('');
  const [filterStartDate, setFilterStartDate] = useState('');
  const [filterEndDate, setFilterEndDate] = useState('');

  useEffect(() => {
    if (appealRequest.isIdle) {
      getAppealRequest();
    }
  }, []);
  // return useMemo(
  // 	() =>

  const getLabelFilterDate = () => {
    if (!filterStartDate && !filterStartDate) {
      return 'Tanggal: Semua';
    }
    return `Tanggal: ${filterStartDate ? moment(filterStartDate).format('DD MMM YYYY') : ''} ${
      filterEndDate ? '- ' + moment(filterEndDate).format('DD MMM YYYY') : '- Akhir'
    }`;
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <Panel>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Typography
              variant="h5"
              style={{
                fontSize: 32,
                fontWeight: 800,
                marginRight: 12,
              }}
            >
              Daftar Sanggahan
            </Typography>
          </div>
          <div style={{ marginTop: 16 }}>
            <FilterChipMenu
              label="Status"
              data={STATUSES}
              value={statusFilter}
              onChange={setStatusFilter}
            />
            <Chip
              clickable
              aria-haspopup="true"
              size="small"
              label={getLabelFilterDate()}
              color="primary"
              variant="outlined"
              style={{
                marginRight: 6,
                marginBottom: 8,
                padding: 8,
              }}
              onClick={() => setOpenFilterDate(true)}
            />
          </div>
          {appealRequest.isReady && appealRequest.data?.length > 0 ? (
            <List
              list={appealRequest.data.filter((e) => {
                const status = statusFilter ? e.status === statusFilter : true;
                const date =
                  filterStartDate && filterEndDate
                    ? e.startTime >= filterStartDate && e.startTime <= filterEndDate
                    : filterStartDate
                    ? e.startTime >= filterStartDate
                    : true;

                return status && date;
              })}
              type="card"
              pagingType="full"
              pagingFirstLast={true}
              withoutSelectArea
            >
              {(item) => (
                <div style={{ width: '100%' }}>
                  <div className={classes.rootList}>
                    <UserPhoto nip={item.nip} />
                    <div className={classes.detailContainer}>
                      <div>
                        <Typography variant="body1" type="bold">
                          {item.employee.fullname}
                        </Typography>
                        <Typography variant="body1" color="#8DA1AB">
                          {item.employee.nip}
                        </Typography>
                        <Typography variant="body1" type="bold" style={{ marginTop: 4 }}>
                          {item.typeName || LEAVE_TYPE[item.category]}
                          {moment(item.startTime).format('D MMM YYYY HH:mm')}
                        </Typography>
                      </div>
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          alignItems: 'flex-end',
                          height: '100%',
                          gap: 8,
                        }}
                      >
                        <div
                          className={
                            item.status === 'approved'
                              ? classes.chipApproved
                              : item.status === 'pending'
                              ? classes.chipPending
                              : classes.chipRejected
                          }
                        >
                          <Typography variant="body1" color={FONT_COLOR[item.status]}>
                            {STATUS_KEYS[item.status]}
                          </Typography>
                        </div>

                        <div
                          className={classes.buttonView}
                          onClick={() => {
                            setAction('view');
                            setSelected(item);
                          }}
                        >
                          <FontAwesomeIcon
                            icon="eye"
                            size="sm"
                            color="#0073d1"
                            style={{
                              marginRight: 5,
                            }}
                          />
                          <Typography variant="body1" color={'#0073d1'}>
                            View
                          </Typography>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </List>
          ) : appealRequest.isFetching ? (
            <Loader height={300} variant="clip" />
          ) : (
            <IllustrationInfo width={150} />
          )}
        </Panel>
      </Grid>
      {action && (
        <AppealDetail
          selected={selected}
          setSelected={setSelected}
          setSelectedAppeal={setSelectedAppeal}
          setDraftEditLeave={setDraftEditLeave}
        />
      )}
      <EditAppealDialog
        draftEditLeave={draftEditLeave}
        selectedAppeal={selectedAppeal}
        setAction={setAction}
        onChangeDraftEditLeave={(value) => setDraftEditLeave(value)}
      />
      <Dialog
        fullWidth
        open={openDownload}
        onClose={() => {
          setOpenDownload();
        }}
        action={{
          label: 'Download Laporan',
          onClick: () => {
            const start = moment(downloadStartDate).format('MM-DD-YYYY');
            const end = moment(downloadEndDate).format('MM-DD-YYYY');
            const url = `https://us-central1-${env.projectId}.cloudfunctions.net/report_excel?start=${start}&end=${end}&type=xlsx`;
            window.open(url, '_blank');
          },
        }}
        title={'Download'}
      >
        <Grid container>
          <Grid item xs={12} style={{ marginBottom: 8 }}>
            Rentang Tanggal
          </Grid>
          <Grid item xs={3}>
            <DateTimePicker
              dateOnly
              maxDate="now"
              value={downloadStartDate}
              onChange={(value) => setDownloadStartDate(new Date(value))}
            />
          </Grid>
          <div style={{ marginRight: 8, marginLeft: 8 }}>-</div>
          <Grid item xs={3}>
            <DateTimePicker
              dateOnly
              maxDate="now"
              value={downloadEndDate}
              onChange={(value) => setDownloadEndDate(new Date(value))}
            />
          </Grid>
        </Grid>
      </Dialog>
      <FilterDateDialog
        filterEndDate={filterEndDate}
        filterStartDate={filterStartDate}
        openFilterDate={openFilterDate}
        setOpenFilterDate={setOpenFilterDate}
        setFilterStartDate={setFilterStartDate}
        setFilterEndDate={setFilterEndDate}
      />
    </Grid>
  );
  // 	[filter, selected, openRejectmodal, appealRequest.isReady]
  // );
});
